module.exports = __webpack_public_path__ + "img/close-icon-notif.85bfdd4b.svg";